import { QueriesAPI } from "./queries";

export const getAll = async ({ locale }) => {
  const data = await QueriesAPI.professionSpecs({
    locale,
    include_groups: true,
  });
  return data;
};

export const SpecAPI = {
  getAll,
};
